/**
 * Centralized z-index values for consistent layering across the application
 * Following AGENTS.md guidelines for z-index management
 */

export const zIndexes = {
  // Navigation and layout
  topNav: 1200,
  sidePanel: 1200,

  // Content layers
  tableHeader: 10,
  tableSubHeader: 9,

  // Overlays and tooltips
  tooltip: 1000,

  // Dev tools
  devTools: 400,
} as const

export type ZIndexKey = keyof typeof zIndexes
